import React from 'react'

import Base from '../_Base'

const PerkSimulcast = (props) => (
  <Base width="40" height="40" viewBox="0 0 40 40" {...props}>
    <path
      d="M20,1 C30.4934102,1 39,9.50658975 39,20 C39,30.4934102 30.4934102,39 20,39 C9.50658975,39 1,30.4934102 1,20 C1,9.50658975 9.50658975,1 20,1 Z M20,3 C10.6111593,3 3,10.6111593 3,20 C3,29.3888407 10.6111593,37 20,37 C29.3888407,37 37,29.3888407 37,20 C37,10.6111593 29.3888407,3 20,3 Z M21.1334545,9.17144283 L21.1334545,20.0187156 C21.1334545,20.2252005 21.0695718,20.4255579 20.9521245,20.5929845 L20.875311,20.6892743 L15.7418564,26.3685471 L14.2581436,25.0274295 L19.133,19.633 L19.1334545,9.17144283 L21.1334545,9.17144283 Z"
      fillRule="evenodd"
    />
  </Base>
)

export default PerkSimulcast
